const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var NfcPayment24 = function NfcPayment24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.141 15.484c-1.676 1.895-4.644 3.157-8.025 3.157C4.884 18.636.641 15.62.641 11.886c0-3.727 4.243-6.75 9.475-6.75 4.369 0 8.045 2.103 9.147 4.965l.284-.055c-1.134-2.95-4.925-5.121-9.431-5.121C4.714 4.925.34 8.04.34 11.886c0 3.844 4.374 6.967 9.776 6.967 3.58 0 6.712-1.371 8.411-3.416",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.31 11.991v-.015a2.723 2.723 0 0 0-.633-1.734.5.5 0 0 0-.437-.155.487.487 0 0 0-.278.823l-.006.003-.002-.003.043.059c.105.15.32.521.329 1.028A1.858 1.858 0 0 1 6 13.022c-.023.033-.044.05-.047.056l.003-.002.006.002a.49.49 0 0 0 .715.667c.407-.485.63-1.098.633-1.733.003-.009 0-.012 0-.021Zm.717 2.772a.508.508 0 0 1-.416-.242.478.478 0 0 1 .032-.532c.006-.005.552-.758.552-1.98 0-1.23-.555-2.051-.557-2.06a.48.48 0 0 1 .776-.559c.036.047.741 1.063.741 2.619 0 1.561-.714 2.522-.75 2.56a.463.463 0 0 1-.378.194Zm1.767.914a.48.48 0 0 1-.387-.77c.006-.01.792-1.102.792-2.887 0-1.816-.798-2.979-.803-2.994a.483.483 0 0 1 .12-.667.48.48 0 0 1 .668.12c.037.055.972 1.426.972 3.538 0 2.122-.946 3.41-.984 3.467a.464.464 0 0 1-.378.193Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M11.528 16.629a.475.475 0 0 1-.43-.267.476.476 0 0 1 .046-.503c.01-.012 1.056-1.46 1.056-3.824 0-2.376-1.056-3.94-1.064-3.96a.473.473 0 0 1-.006-.534.48.48 0 0 1 .8-.015c.05.077 1.233 1.814 1.233 4.506 0 2.699-1.195 4.33-1.242 4.4a.52.52 0 0 1-.393.197Zm12.164-1.079a.215.215 0 0 1-.17-.084l-2.671-4.043c-.34-.522-.721-1.107-1.374-1.078-.782.026-1.407.046-1.416.05a.201.201 0 0 1-.204-.191.201.201 0 0 1 .19-.208l1.41-.046c.875-.036 1.343.682 1.721 1.253l.042.067 2.63 3.976a.205.205 0 0 1-.052.278.224.224 0 0 1-.105.027Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M21.178 16.814c-.62 0-.954-.247-1.14-.375a.313.313 0 0 0-.07-.053c-.166-.094-.659-.568-.82-1.026-.09-.251-.152-.372-.237-.541-.044-.085-.094-.179-.152-.311-.132-.278-.587-.645-.75-.765l-.012-.009c-.088-.07-2.047-1.722-2.364-2.015-.307-.278-.372-.454-.413-.612-.006-.01-.006-.021-.01-.032-.035-.127-.078-.461.259-.836.345-.383.937-.184.964-.176l.018.006 3.45 1.99a.2.2 0 0 1-.125.37.189.189 0 0 1-.073-.027l-3.417-1.963c-.076-.024-.38-.094-.521.064-.206.223-.188.398-.165.466a.09.09 0 0 1 .009.037c.021.092.047.197.29.42.305.272 2.239 1.902 2.348 2 .093.065.678.508.87.909.057.126.105.217.148.302.086.172.162.313.258.589.126.36.543.759.642.814.03.018.065.047.108.073.155.109.413.296.902.296.115 0 .2.091.2.205a.196.196 0 0 1-.197.2Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M16.497 12.518c-.017-.002-1.57-.281-1.957-.34a.538.538 0 0 1-.375-.22.727.727 0 0 1-.105-.51c.011-.078.34-1.918.422-2.322a.595.595 0 0 1 .252-.41.592.592 0 0 1 .421-.07c.114.02 2.046.352 2.537.439a.62.62 0 0 1 .446.281c.14.24.07.513.05.58l-.237 1.049-.396-.088.245-1.075c.012-.038.036-.176-.01-.258-.013-.014-.048-.07-.173-.09a454.48 454.48 0 0 0-2.544-.44l-.014-.006s-.071-.012-.117.02c-.038.027-.062.074-.08.145a535.61 535.61 0 0 0-.415 2.317c-.006.029-.012.15.035.21.011.024.037.047.108.06.387.058 1.898.327 1.96.339l-.053.39Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.114 14.754c-.126 0-.302-.103-.43-.188l-.01-.006c-.307-.216-1.323-.943-1.388-1.01-.117-.094-.2-.282-.232-.378-.058-.18-.014-.387.136-.622.17-.269.524-.249.708-.195l.08.02-.1.39-.088-.027c-.056-.015-.223-.038-.264.032-.073.118-.105.218-.084.276a.586.586 0 0 0 .107.203c.065.052.87.629 1.366.986.082.052.179.106.217.118.076-.006.375-.057.621-.15l.137.375c-.292.105-.658.176-.776.176Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.433 15.741c-.137 0-.33-.03-.588-.146-.443-.211-1.148-.504-1.155-.51l-.02-.012-.018-.014a.744.744 0 0 1-.281-.563c-.015-.386.401-.7.68-.715h.012l.16.012c.053.003.1.027.136.068.034.037.052.09.046.142a.19.19 0 0 1-.207.182l-.136-.005c-.09.011-.292.16-.29.302.003.09.04.176.105.24.138.064.745.316 1.14.5.3.141.452.118.484.109l.023-.015.012.003.753-.181a.197.197 0 0 1 .208.076.225.225 0 0 1 .034.149.198.198 0 0 1-.151.161l-.739.179a.463.463 0 0 1-.207.041v-.003Z",
      fill: "#000",
    })
  );
};
NfcPayment24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: NfcPayment24,
};
export function NfcPayment(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'NfcPayment' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
